import { Container, Typography, Box, Divider } from "@mui/material";
import NextBreadcrumbs from "../component/NextBreadcrumbs";
import Page from "../component/Page";
import ReusableTabs from "../component/ReusableTabs";

const spc = [
  {
    label: "Day 1 Convective Outlook",
    src: "https://www.spc.noaa.gov/products/outlook/day1otlk.html",
  },
  {
    label: "Day 2 Convective Outlook",
    src: "https://www.spc.noaa.gov/products/outlook/day2otlk.html",
  },
  {
    label: "Day 3 Convective Outlook",
    src: `https://www.spc.noaa.gov/products/outlook/day3otlk.html`,
  },
  {
    label: "Day 4-8 Convective Outlook",
    src: `https://www.spc.noaa.gov/products/exper/day4-8/`,
  },

];

const harzardMaps = [{
  label: "Day 3-7 US Hazard Map",
  src: "https://origin.wpc.ncep.noaa.gov/threats/final/hazards_d3_7_contours.png"
}, {
  label: "Day 8-14 US Hazard Map",
  src: "https://www.cpc.ncep.noaa.gov/products/predictions/threats/hazards_d8_14_contours.png"
}];


export default function EmergencyManagement() {
  return (
    <Page>
      <img src="./background/emergency_management.jpg" style={{ width: "100%", maxHeight: 250, objectFit: "cover", objectPosition: "center 30%" }}></img>
      <Container sx={{ py: 5 }}>
        <NextBreadcrumbs></NextBreadcrumbs>
        <Box>
          <Typography variant="h3">Emergency Management</Typography>
          <Typography variant="body1" sx={{ textAlign: "justify", py: 3 }}>Kentucky is susceptible to a wide range of severe weather, including floods, tornadoes, severe wind, hail, lightning, heavy snow, sleet, and freezing rain. However, the state’s complex topography makes it even more vulnerable to its effects. For example, while Kentucky ranks in the top half of all states in the annual number of tornadoes and severe storms, it’s ranked in the top 15 states in the number of fatalities and injuries from tornadoes. In working with the state’s emergency management community, the Kentucky Mesonet helps monitor high-impact weather in real-time, allowing for faster warnings and response, and a much safer, better prepared citizenry.
          </Typography>

          <iframe src="https://radar.weather.gov/?settings=v1_eyJhZ2VuZGEiOnsiaWQiOiJ3ZWF0aGVyIiwiY2VudGVyIjpbLTg2LjQ2OSwzOC4wOF0sImxvY2F0aW9uIjpbLTg2LjQ0NiwzNi45OTVdLCJ6b29tIjo3LjA1MzMzMzMzMzMzMzMzMX0sImFuaW1hdGluZyI6dHJ1ZSwiYmFzZSI6InN0YW5kYXJkIiwiYXJ0Y2MiOmZhbHNlLCJjb3VudHkiOmZhbHNlLCJjd2EiOmZhbHNlLCJyZmMiOmZhbHNlLCJzdGF0ZSI6ZmFsc2UsIm1lbnUiOnRydWUsInNob3J0RnVzZWRPbmx5IjpmYWxzZSwib3BhY2l0eSI6eyJhbGVydHMiOjAuOCwibG9jYWwiOjAuNiwibG9jYWxTdGF0aW9ucyI6MC44LCJuYXRpb25hbCI6MC42fX0%3D" style={{ width: "100%", height: 700, minHeight: 700, border: 0 }}></iframe>
          <Divider sx={{ my: 5 }}></Divider>
          <ReusableTabs
            items={harzardMaps}
            panelHeight={700}
          ></ReusableTabs>
          <Divider sx={{ my: 5 }}></Divider>
          <ReusableTabs
            items={spc}
            iframe
            panelHeight={700}
          ></ReusableTabs>


        </Box>
      </Container>
    </Page>
  );
}
